import { useRowPagination } from "hooks/useRowPagination";

import ServicesAndClaimsRow from "./ServicesAndClaimsRow";
import CustomerRowPagination from "components/General/CustomerRowPagination";

export default function ClaimsTab({ data }) {
  const { rowsForDisplay: current, rowPaginationProps: paginationProps } =
    useRowPagination(data);

  return (
    <>
      {current.map((claim, key) => {
        return (
          <ServicesAndClaimsRow
            key={`${claim.id} - ${key}`}
            data={claim}
            type="claim"
          />
        );
      })}

      <CustomerRowPagination {...paginationProps} />
    </>
  );
}
